import React from "react";

// Ant Design
import { Table, Tag } from "antd";
import moment from "moment";

export const demographicsAudienceTableColumn = [
  Table.SELECTION_COLUMN,
  Table.EXPAND_COLUMN,
  {
    title: "Audience Name",
    dataIndex: "name",
    key: "name",
    render: text => <span>{text}</span>,
  },
  {
    title: "Reach",
    dataIndex: "reachCount",
    key: "reachCount",
    align: "right",
    render: reachCount => {
      return <span>{reachCount ? reachCount.toLocaleString() : 0}</span>;
    },
  },
  {
    title: "Created",
    dataIndex: "createdAt",
    key: "createdAt",
    render: createdAt => moment(createdAt).format("M/D/YYYY"),
  },
  {
    title: "Published",
    dataIndex: "published",
    key: "published",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Tags",
    key: "tags",
    dataIndex: "tags",
    render: (_, { tags }) => (
      <>
        {tags &&
          tags.map(tag => {
            return <Tag key={tag}>{tag}</Tag>;
          })}
      </>
    ),
  },
];
